var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-paginator"},[_vm._t("default",null,null,{ page: _vm.currentPage, pages: _vm.pages, pageData: _vm.pageData, setPage: _vm.setPage })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }